import React from "react";
import styles from './LegalText.module.scss'
import classNames from "classnames";

export const LegalText: React.FC = () => {
  return (
    <div id="legalText" className={styles.LegalText}>
      <p className={classNames(styles.text)}>
        A proteção dos seus dados pessoais é um dos maiores compromissos da Nissan do Brasil. Utilizamos os seus dados
        para proporcionar o melhor serviço e atendimento. Sendo assim, favor indicar abaixo se aceita o tratamento dos
        seus dados de contato. Ao clicar no botão acima, você autoriza a Nissan do Brasil e/ou Concessionário
        devidamente
        selecionado, a coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão,
        distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da informação,
        modificação, comunicação, transferência, difusão ou extração, bem como informações pertinentes ao veículo de
        interesse, incluindo comunicações comerciais e publicidade de acordo com os meus hábitos de consumo e
        navegação
        pelos meios físicos e digitais/eletrônicos, respeitando a privacidade.
      </p>
      <p className={classNames(styles.text)}>
        RESPONSÁVEL PELO TRATAMENTO DE DADOS: Nissan do Brasil; FINALIDADES: Trataremos os seus dados pessoais para
        realizar uma gestão mais assertiva, enviando ao usuário comunicações comerciais personalizadas, bem como
        informação relevante sobre veículos e serviços e/ou pesquisas de satisfação e atendimento. DESTINATÁRIOS:
        Limitamos a comunicação dos dados pessoais a outras empresas contratadas pela Nissan do Brasil. DIREITOS:
        Incluir,
        retificar e eliminar os dados, assim como outros direitos, como se explica na informação adicional. Para
        exercer
        qualquer dos direitos indicados, assim como para revogar o consentimento, pode ligar para o número de
        Atendimento
        ao Cliente 0800 011 1090. TIPOLOGIA DE DADOS: Tratamos unicamente os dados necessários para cada uma das
        finalidades acima identificadas. INFORMAÇÃO ADICIONAL: Pode consultar a informação adicional e detalhada sobre
        a Proteção de Dados acessível <a href="https://www.nissan.com.br/lgpd.html" target="_blank">aqui</a>.
      </p>
    </div>
  )
}